<po-page-default
  [p-breadcrumb]="breadcrumb"
  [p-title]="tituloPagina"
>

  <div class="po-row po-mb-2" *ngIf="!modoVisualizacao">
    <label class="po-md-3">
      <input
        type="file"
        accept=".xlsx,.xls,.csv"
        style="display:none"
        #fileInput
        (change)="importarPlanilha($event)"
      />
      <po-button
        p-label="Importar Planilha"
        p-kind="secondary"
        (p-click)="fileInput.click()"
      ></po-button>
    </label>
  </div>

  <h2 class="po-md-12 po-font-subtitle po-mb-1">Lotes do Inventário</h2>

  <div class="po-row">
    <po-table
      class="po-sm-12 po-md-12 po-lg-12"
      [p-striped]="true"
      [p-items]="lotes"
      [p-columns]="colunas"
      p-spacing="small"
      [p-height]="400"
      [p-hide-columns-manager]="true"
    ></po-table>
  </div>

  <div class="po-row po-mt-2">
    <po-button
      *ngIf="!modoVisualizacao"
      class="po-xl-2 po-md-4 po-mt-2"
      p-label="Salvar"
      p-kind="primary"
      (p-click)="salvar()"
    ></po-button>
    <po-button
      class="po-xl-2 po-md-4 po-mt-2"
      [p-label]="modoVisualizacao ? 'Voltar' : 'Cancelar'"
      p-kind="secondary"
      (p-click)="cancelar()"
    ></po-button>
  </div>

</po-page-default>

<po-modal
  #qtdModal
  p-title="Confirmar Salvamento"
  [p-primary-action]="confirmarSalvar"
  [p-secondary-action]="cancelarQuantidade"
  [p-hide-close]="true"
>
  <p class="po-mb-2">Confirma o salvamento deste inventário com {{ lotes.length }} lote(s)?</p>
</po-modal>
